// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const readAssigned=1;
const readOwnTeam=2;
const readAccessAll=4;
const readAccessAllUnrestricted=8;
const readAny=readAssigned+readOwnTeam+readAccessAll+readAccessAllUnrestricted;
const writeAssigned=0x10;
const writeOwnTeam=0x20;
const writeAccessAll=0x40;
const writeAccessAllUnrestricted=0x80;
// eslint-disable-next-line
const writeAny=writeAssigned+writeOwnTeam+writeAccessAll+writeAccessAllUnrestricted;
const processInitiator=0x100;
const processOwner=0x200;

export const allTags=['Account','orgTable','activeStates','instanceState','structure','process','instance','users','login','comment','permissions','access','userRecord','template'];
function standardisedReturn(result, error, input, tags)
	{
	
	if (tags===undefined)
		{
		console.log(result,error,input);
		return [];
		}
	if (result?.failure)
		{
		if (result.failure==="not logged in")
			;
		else if (input&&input.onFailure)
			; //input.onFailure(result.failure); fail silently
		else 
			alert(result.failure);
		}
	if (result?.success)
		{
//		console.log(result,input,tags);
//		console.log(tags);
		return tags;
		}
	console.error(result,error,input);
	return tags;
	}
// Define a service using a base URL and expected endpoints
const rawBaseQuery=fetchBaseQuery(
	{
	baseUrl:'https://docsasudo.com',
	prepareHeaders:(headers)=>
		{
		var token=localStorage.getItem('authToken');
		
		if (token)
			{
			token=JSON.parse(token);
			console.log(token);
			headers.set('Authorization',`Bearer ${token.jwt}`);
			}
		else	
			console.log("no token");
		return headers;
		},
	credentials:'include',
	});


const authenticatedBaseQuery=async (args,api,extraOptions)=>
	{
	const token=localStorage.getItem('authToken');
	if (!token)
		{
		return {
			error:{
				status:402,
				data:{
					failure:'not logged in'
					}
				}
			};
		}

	return rawBaseQuery(args,api,extraOptions);
	};
	
	
export const databaseViewApi = createApi({
  reducerPath: 'databaseViewApi',
  baseQuery: authenticatedBaseQuery,
  tagTypes: allTags,
  endpoints: (builder) => ({
	getOrgInfo: builder.query({
		query: () => {
			return ({
			url: `processflow.php`,
			method:'post',
			body: {action:'getOrgInfo'},			
			})},
		providesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs, ['orgTable']),
		}),
	completeInstance:builder.mutation({
		query: ({instance,reason}) => {
			return ({
				url: `processflow.php`,
				method:'post',
				body: {action:'completeInstance',instance,reason},			
				})
			},
		invalidatesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs,allTags)
		}),
	updateOrgSettings:builder.mutation({
		  // note: an optional `queryFn` may be used in place of `query`
		query: ({siteSettings}) => {
			return ({
				url: `processflow.php`,
				method:'post',
				body: {action:'updateOrgSettings',siteSettings},			
				})
			},
		invalidatesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs,['orgTable'])
		}),
	rename:builder.mutation({
		  // note: an optional `queryFn` may be used in place of `query`
		query: ({newName, oldName, type}) => {
			return ({
				url: `processflow.php`,
				method:'post',
				body: {action:'rename',newName, oldName, type},			
				})
			},
		invalidatesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs,allTags)
		}),
	publish:builder.mutation({
		  // note: an optional `queryFn` may be used in place of `query`
		query: (input) => {
			var item="ZZ01"+btoa(JSON.stringify(input.dataToSave));
			var dataToSave={...input.dataToSave};
			dataToSave.components=item;
			dataToSave._category=input.category;
			dataToSave._name=input.name;
			dataToSave.prefix=input.prefix?input.prefix:"";
			dataToSave.action="save";
			console.log(dataToSave);
			return ({
				url: `processflow.php`,
				method:'post',
				body: dataToSave,			
				})
			},
		invalidatesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs,allTags)
		}),
	loadProcess: builder.query({
		query: (id) => `processflow.php?action=loadProcess&processId=${id}`,
		providesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs, [{type: 'process', id: inputs}]),
		transformResponse: (responseData, meta, arg) =>
			{
			var i;
			if (responseData.data)
				for (i=0;i<responseData.data.length;i++)
					{
					if (responseData.data[i].components.startsWith("ZZ"))
						responseData.data[i].components=atob(responseData.data[i].components.substring(4));
					}
//			console.log(responseData);
			return responseData;
			},
		}),
	retrieve:builder.query({
		query: ({category, name}) => {
			var dataToSave={};
			dataToSave.id=name;
			dataToSave._category=category;
			dataToSave._name=name;
			dataToSave.action="open";

			return ({
			url: `processflow.php`,
			method:'post',
			body: dataToSave,			
			})},
		transformResponse: (responseData, meta, arg) =>
			{
			var i;
			if (responseData.data)
				for (i=0;i<responseData.data.length;i++)
					{
					if (responseData.data[i].components.startsWith("ZZ"))
						responseData.data[i].components=atob(responseData.data[i].components.substring(4));
					}
//			console.log(responseData);
			return responseData;
			},
			
		providesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs, [{type:'process',id:inputs.name}]),
		}),
	getActiveStates: builder.query({
		query: ({processType,activeOnly,filterMode}) => ({
			url: `processflow.php`,
			method:'post',
			body: {action:'activeStates',filterMode,access:(processOwner|processInitiator|readAny),processType,activeOnly},
			}),
		providesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs, ['activeStates','process']),
		}),  
	closeExecution:builder.mutation({
		query:({executionID})=>({
			url:'processflow.php',
			method:'POST',
			body:{
				action:'closeExecution',
				executionID
				}})
		}),
	loadCurrentInstanceStateData: builder.query({
		query: ({instanceID,stateID}) => ({
			url: `processflow.php`,
			method:'post',
			body: {action:'loadCurrentInstanceStateData',instanceID, stateID},
			}),
		providesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs, [{type:'instanceState',id:inputs.instanceID}]),
		}),
	getMemberAccess: builder.query({
		query: ({instance}) => ({
			url: `processflow.php`,
			method:'post',
			body: {action:'getMemberAccess',instance},			
			}),
		providesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs ,[{type:'access',id:inputs.instance}]),
		}),
	addMemberAccess:builder.mutation({
		  // note: an optional `queryFn` may be used in place of `query`
		query: ({user,access,instance}) => ({
			url: `processflow.php`,
			method:'post',
			body: {action:'addMemberAccess',user,access,instance},			
			}),
		invalidatesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs,[{type:'access',id:inputs.instance}])
		}),
	fileUpload:builder.mutation({
		  // note: an optional `queryFn` may be used in place of `query`
		query: ({file}) => ({
			url: `processflow.php`,
			method:'post',
			body: {action:'fileUpload',myFile:file},			
			}),
		invalidatesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs,[])
		}),	
    getFormList: builder.query({
		query: ({type,active}) => {	
			return `processflow.php?action=formList&type=${type}`}
			,
		providesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs, ['structure']),
		}),
	loadUser:builder.query({
		query: () => ({
			url: `processflow.php`,
			method:'post',
			body: {action:'getUserView'},			
			}),
		providesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs, ['users'],),
		}),
	checkPermissions:builder.query({
		query: () => ({
			url: `processflow.php`,
			method:'post',
			body: {action:'checkPermissions'},			
			}),
		providesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs, ['permissions'],),
		}),
	getProcessFromInstance:builder.query({
		query: ({instanceID}) => ({
			url:'processflow.php',
			method: 'post',
			body: {action:'getProcessFromInstance',instanceID}
			}),
		providesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs, [{type: 'process', id: inputs}]),
		}),
	checkAccess:builder.query({
		query: ({instance,state}) => ({
			url:'processflow.php',
			method: 'post',
			body: {action:'checkAccess',instance,state}
			}),
		providesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs, []),
		}), 	
	deleteUser: builder.mutation({
		  // note: an optional `queryFn` may be used in place of `query`
		query: ({id}) => ({
			url: `processflow.php`,
			method:'post',
			body: {action:'deleteUser',id},			
			}),
		invalidatesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs,allTags)
		}),
	addUser: builder.mutation({
		  // note: an optional `queryFn` may be used in place of `query`
		query: ({userInfo,showUnassigned,areasObject, rolesObject}) => ({
			url: `processflow.php`,
			method:'post',
			body: {action:'addUser',showUnassigned,userInfo,areasObject,rolesObject},			
			}),
		invalidatesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs,allTags)
		}),
	updatePrefix:builder.mutation({
		  // note: an optional `queryFn` may be used in place of `query`
		query: ({instance,prefix}) => ({
			url: `processflow.php`,
			method:'post',
			body: {action:'updatePrefix',instance,prefix},			
			}),
		invalidatesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs,[])
		}),
	addAssignment:builder.mutation({
		  // note: an optional `queryFn` may be used in place of `query`
		query: ({instanceID,teamName, staffName}) => ({
			url: `processflow.php`,
			method:'post',
			body: {action:'addAssignment',teamName,staffName,instanceID},			
			}),
		invalidatesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs,allTags)
		}),
	addTransitionRecord: builder.mutation({
		  // note: an optional `queryFn` may be used in place of `query`
		query: ({transitionID, stateID,instanceID}) => ({
			url: `processflow.php`,
			method:'post',
			body: {action:'addTransitionRecord',transitionID,stateID,instanceID},			
			}),
		invalidatesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs,['instance'])
		}),
	setInstanceDueDate:builder.mutation({
		  // note: an optional `queryFn` may be used in place of `query`
		query: ({instance,due,prefix}) => ({
			url: `processflow.php`,
			method:'post',
			body: {action:'setInstanceDueDate',instance,due,prefix},			
			}),
		invalidatesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs,allTags)
		}),
	getProcessInstances:builder.query({
		query: ({showClosed,extraUser,processType}) => ({
			url:'processflow.php',
			method: 'post',
			body: {action:'getProcessInstances',showClosed,extraUser,processType}
			}),
		providesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs, []),
		}), 
	createProcessInstance: builder.mutation({
		query: ({id,prefix}) => ({
			url: `processflow.php`,
			method:'post',
			body: {action:'createProcessInstance',processID:id,prefix:prefix},			
			}),
		invalidatesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs,['activeStates','process',{type:'process',id:inputs.id}])
		}),
	loadTemplate:builder.query({
		query: ({type}) => ({
			url:'processflow.php',
			method: 'post',
			body: {action:'loadTemplate',type}
			}),
		providesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs, ['template']),
		}), 
	
	saveTemplate: builder.mutation({
		query: ({template,type}) => ({
			url: `processflow.php`,
			method:'post',
			body: {action:'saveTemplate',template,type},			
			}),
		invalidatesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs,['template'])
		}),
	loadUserRecord:builder.query({
			query: ({id}) => ({
				url:'processflow.php',
				method: 'post',
				body: {action:'loadUserRecord',id}
				}),
			providesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs, [{type:'userRecord',id:inputs.id}]),
			}), 
	loadInstanceStateData:builder.query({
			query: ({id}) => ({
				url:'processflow.php',
				method: 'post',
				body: {action:'loadInstanceStateData',id}
				}),
			providesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs, [{type:'instanceState',id:inputs.id}]),
			}), 

	completeProcessState: builder.mutation({
		  // note: an optional `queryFn` may be used in place of `query`
		query: ({instanceID, stateID,executionID}) => ({
			url: `processflow.php`,
			method:'post',
			body: {action:'completeProcessState',instanceID,stateID,executionID},			
			}),
		invalidatesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs,['instance',{type:'instance',id:inputs.instanceID}])
		}),
	loadComments:builder.query({
		query: ({instance}) => ({
			url:'processflow.php',
			method: 'post',
			body: {action:'loadComments',instance}
			}),
		providesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs, [{type:'comment',id:inputs.instance}]),
		}), 
	listInstanceForms: builder.query({
		query: ({instance}) => ({
			url:'processflow.php',
			method: 'post',
			body: {action:'listInstanceForms',instance}
			}),
		providesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs, [{type:'comment',id:inputs.instance}]),
		}), 
	listInstanceStateData: builder.query({
		query: ({instance,state}) => ({
			url:'processflow.php',
			method: 'post',
			body: {action:'listInstanceStateData',instance,state}
			}),
		providesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs, [{type:'state',id:inputs.instance}]),
		}), 
			
	addComment: builder.mutation({
		  query: ({comment,instance}) => {
			return ({
				url: 'processflow.php',
				method:'post',
				body: {action:'addComment',comment,instance},
				})
			},
		  onQueryStarted: async (item, { dispatch, queryFulfilled }) =>
			{
			console.log("got ehre'",item);
			const patchResult = dispatch(
				databaseViewApi.util.updateQueryData('loadComments', {instance:item.instance}, (draft) => 
					{
					console.log(JSON.stringify(draft.data));
					draft.data.push(item);
					// Optimistically update the item in the cached list
					/*const existingItem = draft.find((i) => i.id === item.id);
					if (existingItem) 
						{
						Object.assign(existingItem, item);
						}
					*/
					})
				);
			try {
				await queryFulfilled;
				} 
			catch 
				{
				patchResult.undo(); // Revert if the server request fails
				}
			},
			invalidatesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs,[{type:'comment',id:inputs.instance}])
		}),
	deleteData: builder.mutation({
		query: ({name,type}) => ({
			url: 'processflow.php',
			method:'post',
			body: {action:'delete',name,type},
			}),
		invalidatesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs,allTags)
		}),
	publishProcessInstanceData: builder.mutation({
		query: ({data,instance,state,name}) => ({
			url: 'processflow.php',
			method:'post',
			body: {action:'publishProcessInstanceData',data,instance,state,name},
			}),
		invalidatesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs,[{type:'instanceState',id:inputs.instance}])
		}),
	createProcessStateEntry: builder.mutation({
		query: ({instance, stateID, description,owner,parentID}) => ({
			url: `processflow.php?action=createProcessStateEntry&instanceID=${instance}&state=${stateID}&description=${description}&owner=${owner}&parentID=${parentID}`,	
			}),
		invalidatesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs,['instance',{type:'instance',id:inputs.instance}])
		}),	

	getAccount:builder.query({
		query:()=>({
			url: 'processflow.php',
			method:"POST",
			body:{
				action:"getAccount"
				}
			}),
		providesTags:["Account"]
		}),	
	}),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { 	useGetActiveStatesQuery, useGetFormListQuery,useLoadProcessQuery,useLoadUserQuery,useGetProcessFromInstanceQuery,useLoadUserRecordQuery,useGetProcessInstancesQuery,
				 useAddUserMutation,useGetMemberAccessQuery,useDeleteUserMutation,
				useLoadCurrentInstanceStateData,useGetOrgInfoQuery,useUpdateOrgSettingsMutation,useSaveTemplateMutation,useLoadTemplateQuery,
				useAddCommentMutation,useLoadCommentsQuery,useListInstanceStateDataQuery,useListInstanceFormsQuery,
				usePublishMutation,useRetrieveQuery,useDeleteDataMutation,useCheckPermissionsQuery,useAddMemberAccessMutation,useFileUploadMutation,
				useCompleteProcessStateMutation,useCreateProcessStateEntryMutation, useCreateProcessInstanceMutation,usePublishProcessInstanceDataMutation,
				useCloseExecutionMutation,useChangeDisplayNameMutation,useGetAccountQuery
				} = databaseViewApi;